export const LOCALE_SITE_MAP: Record<string, string> = {
  'pt-BR': 'br',
  en: 'us',
  es: 'es',
}
